import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search',
  pure: false,
})
export class SearchPipe implements PipeTransform {
  transform(data: any, name: any): any {
    // tslint:disable-next-line:curly
    if (name === undefined || name === 'na') {
      return data;
    }else {
      return data.filter(function(data){
        return data.name.toString().toLowerCase().includes(name.toString().toLowerCase());
        })
    }
 }

}
